<template>
    <Page>
        <main>
            <SectionTitle :title="config.FORBIDDEN_TITLE"/>
            <SectionPicture>
                <ArtWarning :color="config.COLOR_WARNING"/>
            </SectionPicture>
            <SectionText :text="config.FORBIDDEN_DESCRIPTION"/>
            <SectionActions>
                <Button :color="config.COLOR_PRIMARY" :disabled="loading" :to="home">
                    OK
                </Button>
            </SectionActions>
        </main>
    </Page>
</template>
<script>
import { SolutionConsumer, CoreConsumer } from '../../mixins';
import {
    Page, SectionPicture, SectionTitle, SectionText, SectionActions,
} from '../../components/shared';

export default {
    name: 'Forbidden',
    components: {
        Page, SectionPicture, SectionTitle, SectionText, SectionActions,
    },
    mixins: [SolutionConsumer, CoreConsumer],
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/mixins';

main {
    @include container(40px);
    align-content: center;
    flex-grow: 1;
}
</style>
